<ap-modal #baseModal
          [appModalId]="'copy-replicate'"
          [ariaLabel]="mode + ' Disclosure'"
          [title]="mode + ' Disclosure'"
          [closable]="true"
          [style]="{'width': '75rem'}"
          [contentStyle]="{'height': showDisclosure ? '80vh' : 'unset'}"
          (onClose)="closeModalOk('copy-replicate')">
  <div class="copy-replicate-modal-body">
    @if (!showDisclosure) {
<div>
      <div class="flex-container">
        <div class="step-number">1.</div>
        <div class="filter-container">
          <span class="label">Please select the Tax Year</span>
          <ap-dropdown [list]="taxYears" [selectType]="'single'" [title]="selectorDefaultText"
                               [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYear"
                               [attachedDOM]="'body'"
                               (onSelect)="onTaxYearChanged($event)">
                    @for (item of taxYears; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                           [ariaLabel]="setAriaLabel(item, 'Tax Year')"
                                           (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
          </ap-dropdown>
        </div>
      </div>
      <div class="flex-container">
        <div class="filter-container">
          <div class="step-number">2.</div>
          <span class="label">Please select the Return Period</span>
          <ap-dropdown [list]="taxYearPeriods" [selectType]="'single'" [title]="selectorDefaultText"
                               [hideTitleOnInput]="true" [inputAriaLabel]="'Return Period'" [(ngModel)]="selectedPeriod"
                               [attachedDOM]="'body'"
                               (onSelect)="onPeriodChanged($event)">
                    @for (item of taxYearPeriods; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                           [ariaLabel]="setAriaLabel(item, 'Return Period')"
                                           (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
          </ap-dropdown>
        </div>
      </div>
    </div>
}
    @if (showDisclosure) {
<div class="viewport-wrapper">
      <dst-create-disclosure-template-viewport [rowObject]="rowObject"></dst-create-disclosure-template-viewport>
    </div>
}
  </div>
  <ng-template ngTemplate="footer">
    @if (loadingStatementId || loadingStatementData) {
<span class="ap-mt-spacing-2">
      <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
    </span>
}
    @if (!showDisclosure) {
<ap-button [compact]="true" [btnType]="'text'" [label]="'CONTINUE TO COPIED DISCLOSURE'" [icon]="'duplicate-outline'"
               [disabled]="!filtersLoaded || loadingStatementId || loadingStatementData" (onClick)="continue()"></ap-button>
}
    <ap-button [compact]="true" [btnType]="'text'" [label]="'CLOSE'" (onClick)="closeModalOk('copy-replicate')"></ap-button>
  </ng-template>
</ap-modal>

